/**
 * Autopilot für eine Computerpartei auf dem Kanzler-Platz (Zwei-Spieler-Modus).
 * Trifft jeden Monat die Entscheidungen, die sonst der Kanzler-Spieler trifft: Haushalt,
 * Affären, Krisen, Anträge der Opposition, Ressortabstimmung, eigene Gesetzentwürfe.
 */
import { budgetCabinet } from './budget';
import { decide, bestDecision } from './decisions';
import { coordReply, coordWaiting, busyOf, canDraft, issueDraftable, newLaw, ownsLaw } from './coalition';
import { decideCrisis } from './crises';
import { budgetRetry, fiscalGap } from './fiscal';
import { introduce } from './govern';
import { decideOpp } from './media';
import { appoint, scandalDecide } from './ministers';
import { decidePtag } from './party';
import { startRepeal, repealable } from './repeal';
import { rnd } from './rng';
import { score, scoreRaw } from './rules';
import { S } from './state';
import { ISSUES } from '../content/issues';
import { ISS } from '../content/states';
import { isVersus } from './versus';

export const aiChancellor = () => isVersus() && S.mp!.chan === 'ai';

/** Stellschrauben so wählen, dass der Entwurf möglichst gut zum Programm passt. */
function bestParams(T: any) {
  const p: Record<string, number> = Object.fromEntries(T.ps.map((x: any) => [x.id, x.d]));
  for (let k = 0; k < 2; k++) for (const pa of T.ps) {
    const vals = pa.k === 'r' ? [pa.min, Math.round((pa.min + pa.max) / 2 / pa.st) * pa.st, pa.max] : pa.k === 'c' ? pa.o.map((_: string, i: number) => i) : [0, 1];
    let best = p[pa.id], bs = -1;
    for (const v of vals) { p[pa.id] = v; const s = scoreRaw(S.you, S.youW || {}, T.fx(p).pos); if (s > bs) { bs = s; best = v; } }
    p[pa.id] = best;
  }
  return p;
}

export function aiTurn() {
  if (!aiChancellor() || S.phase !== 'govern') return;
  if (S.budget && S.budget.stage === 'draft') budgetCabinet(true);
  if (S.fiscal && !S.budget) { budgetRetry(); if (S.budget && (S.budget as any).stage === 'draft') budgetCabinet(true); }
  if (S.fiscal?.mode === 'sperre' && fiscalGap() > 0 && !S.laws.some((L) => L.rep && !['done', 'failed', 'blocked', 'repealed'].includes(L.stage))) {
    const c = S.laws.filter((L) => L.stage === 'done' && !L.rep && (L.fx.b || 0) < -0.3 && repealable(L)).sort((a, b) => (a.fx.b || 0) - (b.fx.b || 0))[0];
    if (c) startRepeal(c.id);
  }
  if (S.scandal) scandalDecide(true);
  if (S.pickFor) appoint(0);
  if (S.crisis) decideCrisis(0);
  if (S.dec) decide(bestDecision());
  if (S.ptag) decidePtag(false);
  if (S.oppBill) decideOpp(score('YOU', S.oppBill.fx.pos) >= .55);
  for (const L of coordWaiting('YOU')) coordReply('YOU', L.id, score('YOU', L.fx.pos) >= .5 ? 'ok' : 'reject');
  for (const L of S.laws.slice()) {
    if (!ownsLaw('YOU', L)) continue;
    if (L.stage === 'ready') introduce(L);
    else if (L.stage === 'failed' || L.stage === 'blocked') { S.laws = S.laws.filter((x) => x !== L); if (L.iss && S.issues[L.iss]) S.issues[L.iss].law = null; }
  }
  if (busyOf('YOU') < 2 && rnd() < .45) {
    const I = ISSUES.filter((i: any) => S.issues[i.id]?.on && !S.issues[i.id].law && issueDraftable('YOU', i.id)).sort((a: any, b: any) => S.issues[b.id].sev - S.issues[a.id].sev)[0];
    if (I) {
      const opts = (ISS[I.id].laws as any[]).map((T, k) => [T, k] as const).filter(([T]) => !T.custom && canDraft('YOU', T));
      if (opts.length) { const [T, k] = opts[Math.floor(rnd() * opts.length)]; newLaw('YOU', I.id, k, bestParams(T)); }
    }
  }
}
